"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercentValue = formatPercentValue;
// Caps at 2 decimals so an odd stored fraction (e.g. 1/3) reads "33.33%"
// instead of "33.3333333333%"; String(Number(...)) then drops trailing zeros
// so clean values stay "95%" / "100%".
function formatPercentValue(percent) {
    return `${String(Number(percent.toFixed(2)))}%`;
}
//# sourceMappingURL=format.js.map